import React, { useState } from 'react';
import { ClickAwayListener, Tooltip } from '@material-ui/core';

import { HoverTooltipProps } from './HoverTooltip.interfaces';
import { useStyles } from './HoverTooltip.styles';
import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

const HoverTooltip: React.FunctionComponent<HoverTooltipProps> = ({
  hoverTooltipText,
  children,
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return isMobileOrTablet() ? (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        placement={'bottom-start'}
        classes={{ tooltip: classes.tooltip }}
        title={hoverTooltipText}
        PopperProps={{
          disablePortal: true,
        }}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        onClose={handleTooltipClose}
      >
        <div onClick={handleTooltipOpen}>
          {children}
          <div className={classes.mobileWrapper} />
        </div>
      </Tooltip>
    </ClickAwayListener>
  ) : (
    <Tooltip
      placement={'bottom-start'}
      classes={{ tooltip: classes.tooltip }}
      title={hoverTooltipText}
    >
      <div className={classes.controlWrapper}>{children}</div>
    </Tooltip>
  );
};
export default HoverTooltip;
